import * as _ from "lodash";
import { Option } from "../../shared/model/Option";
import { RuleTimeZone } from "./model";
import Time from "shared/Time";

export const expressionOperators: Option[] = [
    {
        value: "Exists",
        label: FRENDS.Localizations.RuleExpressionOperator_Exists
    }, {
        value: "Contains",
        label: FRENDS.Localizations.RuleExpressionOperator_Contains
    }, {
        value: "GreaterThan",
        label: FRENDS.Localizations.RuleExpressionOperator_GreaterThan
    }, {
        value: "LessThan",
        label: FRENDS.Localizations.RuleExpressionOperator_LessThan
    }, {
        value: "Equal",
        label: FRENDS.Localizations.RuleExpressionOperator_Equal
    }
];

export const aggregates: Option[] = [
    {
        value: "Count",
        label: FRENDS.Localizations.RuleFunction_Count
    }, {
        value: "DistinctCount",
        label: FRENDS.Localizations.RuleFunction_DistinctCount
    }, {
        value: "Sum",
        label: FRENDS.Localizations.RuleFunction_Sum
    }, {
        value: "Max",
        label: FRENDS.Localizations.RuleFunction_Max
    }, {
        value: "Min",
        label: FRENDS.Localizations.RuleFunction_Min
    }
];

export const operators: Option[] = [
    {
        value: "LessThan",
        label: FRENDS.Localizations.RuleOperator_LessThan
    },
    {
        value: "GreaterThan",
        label: FRENDS.Localizations.RuleOperator_GreaterThan
    },
    {
        value: "Equal",
        label: FRENDS.Localizations.RuleOperator_Equal
    }
];

export const timePeriodTypes: Option[] = [
    {
        value: FRENDS.Localizations.Minutes,
        label: FRENDS.Localizations.Minutes
    }, {
        value: FRENDS.Localizations.Hours,
        label: FRENDS.Localizations.Hours
    }
];

export const timeZonesAsOptions = (stateTimeZones: RuleTimeZone[] | null): Option[] | null | undefined => {
    return stateTimeZones?.map((x) => {
        return {
            value: x.id,
            label: x.description
        };
    });
};

export const timePeriods: Option[] = [1, 5, 10, 15, 20, 30].map((x) => {
    return {
        value: x,
        label: x.toString()
    };
});

export const hourArray: Option[] = _.range(0, 24, 1).map((i) => {
    const label = Time.parseAndFormatCustom(i.toString(), "H", "HH:mm");
    return {
        value: i,
        label
    };
});
